module.exports = "/images/vendor/flag-icon-css/flags/1x1/sb.svg?d64e984857cd493cbe1176acaba792a4";